export default __webpack_public_path__ + "static/media/about-us-img-10.8f4c996a.jpg";